import * as React from 'react';
import type { EmbedProps as Props } from '.';
import Frame from './components/Frame';
import Image from './components/Image';

const URL_REGEX = new RegExp('^https?://docs.google.com/spreadsheets/d/(.*)$');

export default class GoogleSheets extends React.Component<Props> {
	static ENABLED = [URL_REGEX];

	render() {
		return (
			<Frame
				{...this.props}
				src={this.props.attrs.href.replace('/edit', '/preview')}
				icon={
					<Image
						src="/images/google-sheets.webp"
						alt="Google Sheets Icon"
						width={16}
						height={16}
					/>
				}
				canonicalUrl={this.props.attrs.href}
				title="Google Sheets"
				border
			/>
		);
	}
}
